import React from "react";
import { processStatisticsPercentage, renderStatistics } from "@/modules/statistics";
import { IGameStatisticsClass } from "@/types/StatisticsTypes";
import { getArrayElementCounts } from "@/modules/arrays";

// Note: use this.props.langdata to get language information
export default class P12 extends IGameStatisticsClass {
	constructor() {
		super(null);

		const checkTripleDice = (numAry: number[]) => {
			let hasTriple = false;

			const elementCounts = getArrayElementCounts(numAry);
			Object.keys(elementCounts).forEach(num => {
				if (hasTriple)
					return;

				if (elementCounts[num] === 3)
					hasTriple = true;
			});

			return hasTriple
		};

		this.filtrate = function(history, filter) {
			//Counts periods with triple dices
			let tripleTotal = 0;
			history.forEach(item => {
				const angka = item.angka.split(",");

				//Checks triple dice
				const hasTriple = checkTripleDice(angka.map(num => +num));
				if (hasTriple)
					tripleTotal++;
			});

			const total = history.length - tripleTotal;
			
			switch (filter) {
				case "odd-even":
					let odds = 0, evens = 0;
					history.forEach(item => {
						const angka = item.angka.split(",");
						

						//Checks triple dice
						const hasTriple = checkTripleDice(angka.map(num => +num));
						if (hasTriple)
							return;


						let totalAngka = 0;
						for (const a of angka)
							totalAngka += Number(a);
						
						if (totalAngka % 2)
							odds++;
						else evens++;
					});
					
					this.statisticsArray.top.push([
						<div key="p12gst_0" className="sl-roadmap-circle blue-bg">O</div>,
						<div key="p12gst_1" className="sl-roadmap-circle red-bg">E</div>
					]);
					
					this.statisticsArray.bottom.push([
						processStatisticsPercentage("p12gsb_0", odds, total),
						processStatisticsPercentage("p12gsb_1", evens, total)
					]);
				break;
				case "small-big":
					let smalls = 0, bigs = 0;
					history.forEach(item => {
						const angka = item.angka.split(",");


						//Checks triple dice
						const hasTriple = checkTripleDice(angka.map(num => +num));
						if (hasTriple)
							return;


						let totalAngka = 0;
						
						for (const a of angka)
							totalAngka += Number(a);
						
						if (totalAngka <= 10)
							smalls++;
						else bigs++;
					});
					
					this.statisticsArray.top.push([
						<div key="p12gst_2" className="sl-roadmap-circle blue-circle">S</div>,
						<div key="p12gst_3" className="sl-roadmap-circle red-circle">B</div>
					]);
					
					this.statisticsArray.bottom.push([
						processStatisticsPercentage("p12gsb_2", smalls, total),
						processStatisticsPercentage("p12gsb_3", bigs, total)
					]);
				break;
				default: break;
			}
		};
	}
	

	render() {
		return renderStatistics(this);
	}
}
